import { Sections } from './DetailView.types'

export const moreTabViews = [Sections.Sales, Sections.Offers, Sections.History]
